import './card-description.css'
import cardImg from '../../assets/img/about/asset 2.png'
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import HandshakeIcon from '@mui/icons-material/Handshake';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';

const CardDescription = () => {
	return (
		<section className="card-description">
			<div className="container">
				<div className="card-holder">
					<img src={cardImg} alt="card-img" />
					<div className="experience-text">
						Seit 2005 <br />
						für Sie im Einsatz
					</div>
				</div>
				<div className="card-desc">
					<span>Über uns</span>
					<h2 className='title'>Mobile Pflege aus Berufung</h2>
					<p>Unsere Pflegekunden brauchen jemanden, der Sie auf dem Weg in die Zukunft begleitet, weil Sie auch im Alter Ihre eigenen vier Wände genießen wollen. Wir, als begeistertes Pflegeteam stehen dafür ein.</p>
					<ul>
						<li><i><EmojiEmotionsIcon /></i> Familiär</li>
						<li><i><HandshakeIcon /></i> Herzlich</li>
						<li><i><AccountBalanceIcon /></i> Nah</li>
						<li><i><ThumbUpIcon /></i> Professionell</li>
					</ul>
					<p>Auf Menschen einzugehen, sowie Vertrauen und familiäre Atmosphäre zu schaffen steht ganz oben auf unserer Liste. Wir verkörpern unser Slogan „Wir pflegen und betreuen Sie dort, wo Sie zu Hause sind“ und setzen es für Sie um</p>
				</div>
			</div>
		</section>
	)
}

export default CardDescription
